export { default } from './ArrowUp'
